import { FormControl, Grid, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import React, { useState, useEffect } from 'react'
import ExitStrategiesProps from './ExitStrategiesProps'

export default function HighLowStrategyInput(props: ExitStrategiesProps) {
  const { backtestSettingInputData, handleInputChange } = props

  const [localLookback, setLocalLookback] = useState<string | null>(null)
  const [localOffset, setLocalOffset] = useState<string | null>(null)

  useEffect(() => {
    setLocalLookback(null)
  }, [backtestSettingInputData.generateTrades.maxLookback])
  useEffect(() => {
    setLocalOffset(null)
  }, [backtestSettingInputData.generateTrades.priceOffset])

  return (
    <>
      <Grid container item spacing={2}>
        <Grid item sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-amount">Max candles lookback</InputLabel>
            <OutlinedInput
              value={
                localLookback !== null
                  ? localLookback
                  : backtestSettingInputData.generateTrades.maxLookback
              }
              name="generateTrades.maxLookback"
              onChange={(e) => setLocalLookback(e.target.value)}
              onBlur={() => {
                if (localLookback !== null) {
                  const p = parseFloat(localLookback)
                  if (!isNaN(p)) handleInputChange('generateTrades.maxLookback', p)
                  setLocalLookback(null)
                }
              }}
              type={'number'}
              inputProps={{ min: 1 }}
              id="outlined-adornment-amount"
              startAdornment={<InputAdornment position="start">#</InputAdornment>}
              label="Max candles lookback"
            />
          </FormControl>
        </Grid>
        <Grid item sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Price offset</InputLabel>
            <OutlinedInput
              value={
                localOffset !== null
                  ? localOffset
                  : backtestSettingInputData.generateTrades.priceOffset
              }
              name="generateTrades.priceOffset"
              onChange={(e) => setLocalOffset(e.target.value)}
              onBlur={() => {
                if (localOffset !== null) {
                  const p = parseFloat(localOffset)
                  if (!isNaN(p)) handleInputChange('generateTrades.priceOffset', p)
                  setLocalOffset(null)
                }
              }}
              type={'number'}
              inputProps={{ step: 0.00001, min: 0 }}
              label="Price offset"
            />
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
